import { render, staticRenderFns } from "./GameSpeedDisplay.vue?vue&type=template&id=b1d6a96e&scoped=true"
import script from "./GameSpeedDisplay.vue?vue&type=script&lang=js"
export * from "./GameSpeedDisplay.vue?vue&type=script&lang=js"
import style0 from "./GameSpeedDisplay.vue?vue&type=style&index=0&id=b1d6a96e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1d6a96e",
  null
  
)

export default component.exports